import React, { useContext } from 'react';

import { H2 } from '@zooplus/ui-components';

import LocResourcesContext from '../../../../common/contexts/LocResourcesContext';

const ProgressBarFirstPhase = ({}): JSX.Element => {
  const GLOBAL_PREFIX: string = 'loy-bp-shutdown';
  const { onFormatLocale } = useContext(LocResourcesContext);
  return (
    <div className={`${GLOBAL_PREFIX}-progress-bar`}>
      <H2 style={{ marginTop: '40px' }}>{onFormatLocale?.('loy.bp.shutdown.progressbar.title')}</H2>
      <div className={`${GLOBAL_PREFIX}-progress-bar__box`}>
        <div className={`${GLOBAL_PREFIX}-progress-bar__chart__text--up`}>
          <div className={`${GLOBAL_PREFIX}-progress-bar__chart__text--up__item`}>
            <div className={`${GLOBAL_PREFIX}-progress-bar__chart__text--title`}>
              {onFormatLocale?.('loy.bp.shutdown.progressbar.now')}
            </div>
            <div className={`${GLOBAL_PREFIX}-progress-bar__chart__text--description`}>
              {onFormatLocale?.('loy.bp.shutdown.progressbar.now.description')}
            </div>
          </div>
          <div className={`${GLOBAL_PREFIX}-progress-bar__chart__text--up__item`}>
            <div className={`${GLOBAL_PREFIX}-progress-bar__chart__text--title`}>
              {onFormatLocale?.('loy.bp.shutdown.progressbar.end.date')}
            </div>
            <div className={`${GLOBAL_PREFIX}-progress-bar__chart__text--description`}>
              {onFormatLocale?.('loy.bp.shutdown.progressbar.end.date.description')}
            </div>
          </div>
        </div>
        <div className={`${GLOBAL_PREFIX}-progress-bar__chart`}>
          <div className={`${GLOBAL_PREFIX}-progress-bar__chart__point`}></div>
          <div className={`${GLOBAL_PREFIX}-progress-bar__chart__point`}></div>
          <div className={`${GLOBAL_PREFIX}-progress-bar__chart__point`}></div>
        </div>
        <div className={`${GLOBAL_PREFIX}-progress-bar__chart__text--bottom`}>
          <div className={`${GLOBAL_PREFIX}-progress-bar__chart__text--bottom__item`}>
            <div className={`${GLOBAL_PREFIX}-progress-bar__chart__text--title`}>
              {onFormatLocale?.('loy.bp.shutdown.progressbar.start.date')}
            </div>
            <div className={`${GLOBAL_PREFIX}-progress-bar__chart__text--description`}>
              {onFormatLocale?.('loy.bp.shutdown.progressbar.start.date.description')}
            </div>
          </div>
        </div>
      </div>
      <p>{onFormatLocale?.('loy.bp.shutdown.progressbar.paragraph-1')}</p>
      <p>{onFormatLocale?.('loy.bp.shutdown.progressbar.paragraph-2')}</p>
    </div>
  );
};

export default ProgressBarFirstPhase;
